/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateSummaryDataSchema = z.object({
	name: z.string().nullable(),
	email: z.string(),
	applicationCount: z.number(),
})

export type CandidateSummaryDataSchema = z.infer<typeof candidateSummaryDataSchema>
